import React from "react";
import { TabType } from "../../types";
import { TabBar, TabItem } from "../TabBar/TabBar";
import {
  MapIcon,
  // WebcamsIcon,
  // ContestIcon,
  FlowersIcon,
  NetworkingIcon,
  GiftIcon,
} from "../TabBar/TabIcons";
//import { ProfileIcon } from "../ProfileIcon/ProfileIcon";

interface TabManagerProps {
  webcamsCount: number;
  contestData: any;
  telegramUser: any;
  activeTab: TabType;
  onTabChange: (tabId: TabType) => void;
  theme?: string;
  className?: string;
  citySettings?: {
    is_flowers_enabled?: boolean;
    is_networking_enabled?: boolean;
  };
}

export const TabManager: React.FC<TabManagerProps> = ({
  //webcamsCount,
  //telegramUser,
  activeTab,
  onTabChange,
  theme,
  className = "",
  citySettings,
}) => {
  const tabs: TabItem[] = [
    { id: "summary", label: "ДПС", icon: <MapIcon /> },
    // {
    //   id: "webcams",
    //   label: "Камеры",
    //   icon: <WebcamsIcon />,
    //   badge: webcamsCount > 0 ? webcamsCount : undefined,
    // },
    // ...(contestData
    //   ? [
    //       {
    //         id: "contest" as TabType,
    //         label: "Конкурс",
    //         icon: <ContestIcon />,
    //       },
    //     ]
    //   : []),

    ...(citySettings?.is_flowers_enabled === true
      ? [
          {
            id: "flowers" as TabType,
            label: "Цветы",
            icon: <FlowersIcon />,
          },
        ]
      : []),
    ...(citySettings?.is_networking_enabled === true
      ? [
          {
            id: "networking" as TabType,
            label: "Нетворкинг",
            icon: <NetworkingIcon />,
          },
        ]
      : []),
    {
      id: "gift" as TabType,
      label: "Подарок",
      icon: <GiftIcon />,
    },
    // {
    //   id: "profile",
    //   label: "Профиль",
    //   icon: telegramUser?.photo_url ? (
    //     <img
    //       src={telegramUser.photo_url}
    //       alt="Профиль"
    //       style={{
    //         width: "24px",
    //         height: "24px",
    //         borderRadius: "50%",
    //         objectFit: "cover",
    //       }}
    //     />
    //   ) : (
    //     <ProfileIcon size={24} />
    //   ),
    // },
  ];

  return (
    <TabBar
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
      className={`${theme === "dark" ? "dark" : ""} ${className}`}
    />
  );
};
